import React from "react";

export default function Button(props){
    return (
        <button className=" bg-gradient-to-r transition-opacity duration-200 delay-100 from-yellow-300 via-yellow-300 hover:bg-gradient-to-r hover:from-yellow-400 hover:to-yellow-300 to-yellow-400 lg:px-12 lg:py-5 rounded-full px-6 py-3 shadow-md lg:shadow-lg text-2xl lg:text-4xl text-black/60 ">
            {props.name}                            
        </button> 
    )
}